import React, { useMemo } from "react";

export const CosmicBackground = ({ children }) => {
  const stars = useMemo(
    () =>
      Array.from({ length: 60 }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2 + 0.5,
        delay: Math.random() * 4,
      })),
    [],
  );

  return (
    <div className="relative min-h-screen overflow-hidden grain" data-testid="cosmic-bg">
      {/* Deep space gradient */}
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(ellipse at 20% 20%, rgba(20,30,60,0.6), transparent 50%), radial-gradient(ellipse at 80% 80%, rgba(60,20,80,0.5), transparent 55%), #05070A",
        }}
      />
      {/* Stars */}
      <div className="absolute inset-0 -z-10 pointer-events-none">
        {stars.map((s) => (
          <div
            key={s.id}
            className="absolute bg-white rounded-full twinkle"
            style={{
              top: `${s.top}%`,
              left: `${s.left}%`,
              width: `${s.size}px`,
              height: `${s.size}px`,
              animationDelay: `${s.delay}s`,
            }}
          />
        ))}
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  );
};
